import axios, { AxiosError } from 'axios'
import { errors } from './errors'

type TokenGetter = () => Promise<string>

let getToken: TokenGetter | null = null

export const registerTokenGetter = (fn: TokenGetter): void => {
  getToken = fn
}

// Exported only for test isolation — resets the module-scope singleton between test runs.
export const resetTokenGetterForTests = (): void => {
  getToken = null
}

export const toRuutsError = (error: AxiosError): Error => {
  if (error.response) {
    const message = (error.response.data as { message?: string })?.message ?? error.message
    if (error.response.status >= 400 && error.response.status < 500) {
      return new errors.BusinessEntityError({
        message,
        response: error.response.data,
        needSupport: false,
        status: error.response.status,
      })
    }
    return new errors.UnexpectedEntityError({ message, status: error.response.status })
  }
  return new errors.UnexpectedEntityError({ message: error.message })
}

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_RUUTS_API_URL,
})

apiClient.interceptors.request.use(async config => {
  if (!getToken) {
    throw new Error(
      'API token getter not registered — render <ApiAuthBridge /> inside Auth0Provider',
    )
  }
  config.headers.set('Authorization', `Bearer ${await getToken()}`)
  return config
})

apiClient.interceptors.response.use(
  response => response,
  (error: unknown) => Promise.reject(error instanceof AxiosError ? toRuutsError(error) : error),
)
